import React, { useState, useEffect } from "react";
import { Switch, Route } from "react-router";
import LabHeader from "../Header/LabHeader";
import Sidebar from "../Sidebar/Sidebar";
import LessonLabTeacher from "../../pages/LessonLabTeacher/index";
import jsonToken from "jsonwebtoken";
import s from "./Layout.module.scss";
import { getPlaygroundContext } from "../../pages/LessonLabTeacher/playgroundStorage";

const TeacherLabLayout = () => {
  const [count, setCount] = useState(0);
  const url = (window.location.href).split("#");

  const navigateHome = () => {
    const context = getPlaygroundContext();
    const destination = context.returnPath || context.homePath || "/home";
    window.open(`${url[0]}#${destination}`, "_self");
    document.location.reload(true);
  };

  useEffect(() => {
    document.body.classList.remove("admin-nav");
  });

  const token = localStorage.getItem("access_token");
  const accessToken = token ? jsonToken.decode(token) : null;
  return (
    <div className={s.root}>
      <Sidebar notificationCount={(data) => {
        setCount(data);
      }} />
      <div className={s.wrap}>
        <LabHeader role={accessToken?.roles?.[0]} count={count} />
        <div className="home-icon"><i className="fa fa-home" onClick={navigateHome} aria-hidden="true"></i></div>
        <Switch>
          <Route
            path="/LessonLabTeacher/:engageStepId/:evaluateStepId/:explainStepId/:exploreStepId/:extendStepId"
            component={LessonLabTeacher}
          />
        </Switch>
      </div>
    </div>
  );
};

export default TeacherLabLayout;
